// extracted by mini-css-extract-plugin
module.exports = {"footer500Bottom":"Bottom_footer-500-bottom__ScS0V","footer500BottomUntilLaptop":"Bottom_footer-500-bottom--untilLaptop__cCp8o"};